module.exports = __webpack_public_path__ + "img/csv.083d9536.png";